import React from 'react';
import styled from 'styled-components';

/**
 * Label Component - Typography component for field labels
 *
 * @param {Object} props
 * @param {string} props.text - Label text to display
 * @param {string} [props.htmlFor] - ID of the associated form element
 * @param {boolean} [props.required] - Whether the field is required (shows asterisk)
 * @param {string} [props.className] - Additional CSS class
 */
const Label = ({ text, htmlFor, required = false, className }) => {
  return (
    <LabelText htmlFor={htmlFor} className={className}>
      {text}
      {required && <RequiredIndicator aria-label="required">*</RequiredIndicator>}
    </LabelText>
  );
};

const LabelText = styled.label`
  /* Reset global styles */
  position: relative !important;
  top: auto !important;
  margin-top: 0 !important;
  height: auto !important;

  /* Figma design specs */
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.15px;
  line-height: 1.2;
  color: rgba(69, 68, 107, 0.8) !important;

  /* Layout */
  display: flex !important;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  padding-left: 8px;
`;

const RequiredIndicator = styled.span`
  color: inherit;
`;

export default Label;
